import React from "react";
import { Collapse } from "antd";
import ResponseFileConfiguration from "./ResponseFileConfiguration";
import ConvertXMLToJson from "./ConvertXMLToJson";
import MockResponse from "./MockResponse";
import ResponseTransformation from "./ResponseTransformation";

const ResponseHandlingConfiguration = ({ action, updateCallback }) => {
  return (
    <Collapse defaultActiveKey={[]} ghost>
      <Collapse.Panel header="Response handling" key="response-handling">
        <ResponseFileConfiguration action={action} updateCallback={updateCallback} />
        <ConvertXMLToJson action={action} updateCallback={updateCallback} />
        <ResponseTransformation action={action} updateCallback={updateCallback} />
        <MockResponse action={action} updateCallback={updateCallback} />
      </Collapse.Panel>
    </Collapse>
  );
};

export default ResponseHandlingConfiguration;
